// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:446030fa-d468-430d-9259-34feafedc5b4",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_7H2GrzgUN",
    "aws_user_pools_web_client_id": "2t1rh80embjfd6prvgks1pncp5",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://swctcedj3zbb5lkr6xiumt2zpu.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "amplify-core-storage-prod105531-prod",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
